module.exports = __webpack_public_path__ + "static/media/Farma pasa - Transformacija (Kraj).7c967a59.mp3";